// assets
import HowToIcon from 'Components/Icons/HowTo';
import Share from '@mui/icons-material/Share';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: 'Utilities',
    type: 'group',
    children: [
        {
            id: 'inviteLink',
            title: 'Invite Investors',
            type: 'item',
            url: 'https://www.diolog.com.au/invite-your-investors',
            icon: Share,
            breadcrumbs: false,
            external: true,
            target: '_blank'
        },
        {
            id: 'help',
            title: 'How to use Diolog',
            type: 'item',
            url: 'https://www.diolog.com.au',
            icon: HowToIcon,
            breadcrumbs: false,
            external: true,
            target: '_blank'
        }
    ]
};

export default utilities;
